/* OIL TYCOON — pré-carregamento em camadas + cache no aparelho.
   Na abertura o jogo confere o manifest (com a impressão digital de cada arquivo)
   e rebaixa SÓ o que mudou. Camada 1 bloqueia a entrada: imagens + música do Início.
   Camada 2 roda em segundo plano: demais músicas e os vídeos das operações. */

const CACHE = 'oil-assets';
const STAMPS = 'oil_asset_stamps';

let manifest = null;
const done = new Set();
let queue = [];
let running = false;

export const registerCache = async () => {
  if (!('serviceWorker' in navigator)) return;
  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs
      .filter((r) => r.active && r.active.scriptURL.endsWith('/oil-sw.js'))
      .map((r) => r.unregister()));
    await navigator.serviceWorker.register('/sw.js');
  } catch { /* segue sem cache */ }
};

const readStamps = () => {
  try { return JSON.parse(localStorage.getItem(STAMPS) || '{}'); } catch { return {}; }
};

/* Apaga do cache apenas os arquivos cuja impressão digital mudou. */
const dropChanged = async (files) => {
  const old = readStamps();
  const next = {};
  const stale = [];
  files.forEach((f) => {
    next[f.url] = f.hash;
    if (old[f.url] && old[f.url] !== f.hash) stale.push(f.url);
  });
  if (stale.length && 'caches' in window) {
    const cache = await caches.open(CACHE);
    await Promise.all(stale.map((u) => cache.delete(u)));
  }
  localStorage.setItem(STAMPS, JSON.stringify(next));
  return stale.length;
};

const loadManifest = async () => {
  if (manifest) return manifest;
  const r = await fetch('/oil/manifest.json', { cache: 'no-store' });
  const m = await r.json();
  const all = [...m.images, m.music.inicio, ...m.music.rest, ...(m.sfx || []), ...m.videos];
  await dropChanged(all);
  manifest = m;
  return m;
};

const grab = async (url) => {
  if (done.has(url)) return;
  // um arquivo pendurado não pode travar a barra de carregamento
  const ctrl = typeof AbortController !== 'undefined' ? new AbortController() : null;
  const corta = ctrl ? setTimeout(() => ctrl.abort(), 8000) : null;
  try {
    await fetch(url, { cache: 'force-cache', ...(ctrl ? { signal: ctrl.signal } : {}) });
  } catch { /* tenta de novo depois */ } finally {
    if (corta) clearTimeout(corta);
  }
  done.add(url);
};

/** Camada 1 — o jogador espera por isto. */
export const preloadCritical = async (onProgress) => {
  await registerCache();
  let m;
  try {
    m = await loadManifest();
  } catch {
    onProgress?.(100);   // sem manifest: entra e baixa sob demanda
    return;
  }
  const list = [...m.images.map((f) => f.url), m.music.inicio.url,
    ...(m.sfx || []).map((f) => f.url)];
  const total = list.length;
  let ok = 0;
  const report = () => onProgress?.(Math.round((ok / total) * 100));
  report();
  const workers = Array.from({ length: 6 }, async () => {
    while (list.length) {
      await grab(list.shift());
      ok += 1;
      report();
    }
  });
  await Promise.all(workers);
  onProgress?.(100);
};

const pump = async () => {
  if (running) return;
  running = true;
  while (queue.length) await grab(queue.shift());
  running = false;
};

/** Camada 2 — invisível, depois de entrar. */
export const preloadBackground = async () => {
  const m = await loadManifest();
  queue.push(...m.music.rest.map((f) => f.url), ...m.videos.map((f) => f.url));
  pump();
};

/** Fura a fila: o jogador chegou nesta mídia antes do previsto. */
export const prioritize = (url) => {
  if (!url || done.has(url)) return;
  queue = [url, ...queue.filter((u) => u !== url)];
  pump();
};
